import {inject} from '@angular/core';
import {ActivatedRouteSnapshot, Router, RouterStateSnapshot} from '@angular/router';
import {Store} from '@ngrx/store';
import {Observable, of} from 'rxjs';
import {catchError, switchMap} from 'rxjs/operators';
import {environment} from '../../environments/environment';
import {ClareOnboardingService} from '../services/clare/clare-onboarding.service';
import {ProductListActions} from '../features/product-list/store/product-list.actions';

export const clareOnboardingAccountGuard = (
  route: ActivatedRouteSnapshot,
  __state: RouterStateSnapshot
): Observable<boolean> => {
  const clareOBS = inject(ClareOnboardingService);
  const router = inject(Router);
  const store = inject(Store);
  const organizationId = Number(route.params['currentOrgId']);
  const inIframe = window.location !== window.parent.location;

  if (environment.env === 'local' || environment.env === 'development' || !inIframe) {
    return of(true);
  }

  return clareOBS.retrieveAccount(organizationId).pipe(
    switchMap(res => {
      const isOnboarded = ['complete', 'enabled', 'restricted soon', 'restricted_soon', 'pending'].includes(
        res.result.status.toLowerCase().trim()
      );
      store.dispatch(ProductListActions.setClareAccountStatus({clareAccountStatus: res.result.status}));

      if (!isOnboarded) {
        router.navigateByUrl(`org/${organizationId}/clare-onboarding`);
      }

      return of(isOnboarded);
    }),
    catchError(err => {
      if (err.status === 404) {
        store.dispatch(ProductListActions.setClareAccountStatus({clareAccountStatus: 'Missing'}));
        router.navigateByUrl(`org/${organizationId}/clare-onboarding`);
      } else {
        router.navigateByUrl('/error', {
          state: {error: {message: 'An error occurred. Please try again.', code: 'PM-0000'}},
        });
      }
      return of(false);
    })
  );
};
